import { Box } from "@mui/material";
import { MultipleAnglesVideoPlayer } from "components/scrapEyeDataDashboard/VideoPlayer/components/MultipleAnglesVideoPlayer";
import { PlaybackControls } from "components/scrapEyeDataDashboard/VideoPlayer/components/PlaybackControls";
import { DIALOG_SKIP_BUTTON_SECONDS } from "components/scrapEyeDataDashboard/VideoPlayer/constants";
import { useVideoControl } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/VideoControlContext";
import { useSkipAndStepHandlers } from "components/scrapEyeDataDashboard/VideoPlayer/hooks/useSkipAndStepHandlers";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { Dayjs } from "dayjs";
import { LABELLING_GUIDE_SCOPE } from "components/manualReview/hotkeyScopes";

type ExampleVideoPlayerContentProps = Readonly<{
  location: string;
  startIso: string;
  endIso: string;
  events: ScrapEyesEvent[];
  videoStart: Dayjs;
}>;

export const ExampleVideoPlayerContent = ({
  location,
  startIso,
  endIso,
  events,
  videoStart,
}: ExampleVideoPlayerContentProps) => {
  const { state, actions } = useVideoControl();
  const { handleSkipBackward, handleSkipForward } = useSkipAndStepHandlers({
    skipSeconds: DIALOG_SKIP_BUTTON_SECONDS,
  });

  return (
    <>
      <MultipleAnglesVideoPlayer
        hotkeyScope={LABELLING_GUIDE_SCOPE}
        location={location}
        startIso={startIso}
        endIso={endIso}
        events={events}
        videoStart={videoStart}
        showVideoControls={false}
      />
      <Box sx={{ pt: 1 }}>
        <PlaybackControls
          isPlaying={state.isPlaying}
          playbackRate={state.playbackRate}
          onTogglePlayPause={actions.togglePlayPause}
          onSkipBackward={handleSkipBackward}
          onSkipForward={handleSkipForward}
          onSpeedChange={actions.setPlaybackRate}
        />
      </Box>
    </>
  );
};
